import { animate, state, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';

export type TooltipPosition = 'top' | 'bottom';

@Component({
  selector: 'app-smash-tooltip',
  templateUrl: './smash-tooltip.component.html',
  styleUrls: ['./smash-tooltip.component.scss'],
  animations: [
    trigger('animateTooltip', [
      state('in', style({ transform: 'translateY({{startPosition}})' }), { params: { startPosition: '0%' } }),
      state('out', style({ transform: 'translateY({{endPosition}})' }), { params: { endPosition: '4%' } }),
      transition('in => out', animate('1s linear')),
      transition('out => in', animate('1s linear'))
    ]),
  ]
})
export class SmashTooltipComponent implements OnInit {

  // tslint:disable-next-line: no-input-rename
  @Input('position') position: TooltipPosition;
  // tslint:disable-next-line: no-input-rename
  @Input('delay') delay: number;
  @Input() displayed = true;

  state = 'in';
  constantEndPosition = '5%';
  startPosition: string;
  endPosition: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.resolveTooltipPosition();
      this.startTooltipAnimation();
    }
  }

  private resolveTooltipPosition() {
    if (this.position === 'bottom') {
      this.startPosition = '0%';
      this.endPosition = this.constantEndPosition;
    } else if (this.position === 'top') {
      this.startPosition = this.constantEndPosition;
      this.endPosition = '0%';
    }
  }

  private switchState() {
    this.state = this.state === 'in' ? 'out' : 'in';
  }
  private startTooltipAnimation() {
    setInterval(() => {
      this.switchState();

    }, this.delay);

  }

}
